import { getAuth, onAuthStateChanged } from "firebase/auth"
import { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom"

import { login } from "../actions/auth"
import { startLoadingNotes } from "../actions/notes"

import MainScreen from "../components/journal/MainScreen"

import AuthRouter from "./AuthRouter"

const AppRouter = () => {

    const [ checking, setChecking ] = useState(true)
    const [ isLoggedIn, setIsLoggedIn ] = useState(false)

    const dispatch = useDispatch()
    const auth = getAuth()

    useEffect(() => {
        onAuthStateChanged(auth, (user) => {
            if (user?.uid) {
                dispatch(login(user.uid, user.displayName))
                setIsLoggedIn(true)
                
                dispatch(startLoadingNotes(user.uid))
            } else {
                setIsLoggedIn(false)
            }

            setChecking(false)
        })

    }, [ setChecking, setIsLoggedIn ])

    if (checking) {
        return <h1>Loading...</h1>
    }

    return (
        
        <BrowserRouter>

            <Routes>
                <Route path="/auth/*" element={ 
                    (!isLoggedIn) ? <AuthRouter /> : <Navigate to="/" />
                } />
                <Route path="/" element={ 
                    (isLoggedIn) ? <MainScreen /> : <Navigate to="/auth/*" /> 
                } />

                {/* Router redirects */}
                <Route path="/auth" element={ <Navigate replace to="login" />} />
                <Route path="*" element={ <Navigate to="/" /> } />
            </Routes>
        </BrowserRouter>
    )
}

export default AppRouter